import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 登录
const loginAccount = obj => new Promise((resolve, reject) => {
    request({
        url: apis.account_login,
        data: {
            account: obj.account,
            passKey: obj.passKey
        }
    }).then(res => {
        resolve(res);
    })
})


// 用户修改密码
const changePassword = obj => new Promise((resolve, reject) => {
    const {
        token,
        modifyPassForm
    } = obj;
    request({
        url: apis.account_change_password+ '?token=' + token,
        data: modifyPassForm
    }).then(res => {
        resolve(res);
    })
})

// 获取菜单
const allMenu = () => new Promise((resolve, reject) => {
    request({
        url: apis.account_all_menu
    }).then(res => {
        resolve(res);
    })
})

export default {
    loginAccount,
    changePassword,
    allMenu
}



// WEBPACK FOOTER //
// ./src/service/account_api.js